import React from "react";

interface WorkflowLoadingOverlayProps {
  overlayWidth: number;
  message?: string;
}

export const WorkflowLoadingOverlay: React.FC<WorkflowLoadingOverlayProps> = ({
  overlayWidth,
  message = "Building Test...",
}) => {
  return null;
  // TODO
  // return (
  //   <Grid
  //     id={"ai-overlay"}
  //     sx={{
  //       position: "absolute",
  //       inset: 0,
  //       bgcolor: "rgba(0,0,0,0.3)",
  //       zIndex: 1300,
  //       // right: `${overlayWidth}px`,
  //       cursor: "pointer",
  //       display: "flex",
  //       alignItems: "center",
  //       justifyContent: "center",
  //       left: 0,
  //       right: 0,
  //       height: "100%",
  //       width: "100%",
  //       // width: "calc(100% - 400px)",
  //     }}
  //   >
  //     <Grid
  //       sx={{
  //         display: "flex",
  //         alignItems: "center",
  //         gap: 1.5,
  //         color: "white",
  //         px: 2,
  //         py: 1.25,
  //         borderRadius: 1,
  //         bgcolor: "rgba(0,0,0,0.4)",
  //       }}
  //     >
  //       <CircularProgress size={18} color="inherit" thickness={5} />
  //       <Typography variant="body2" sx={{ color: "inherit", fontWeight: 600 }}>
  //         {message}
  //       </Typography>
  //     </Grid>
  //   </Grid>
  // );
};
